// extracted by mini-css-extract-plugin
module.exports = {"ol":"styles_ol__xJz93"};